import React from 'react';
import { Music } from 'lucide-react';
import AudioAssets from './AudioAssets';

const MusicPage: React.FC = () => {
  return (
    <AudioAssets 
      type="music" 
      title="Music"
      icon={<Music size={24} />}
    />
  );
};

export default MusicPage;
